// app/models/concerns/has_user_type.rb

export const userTypes = {
  human: 'HUMAN',
  support_bot: 'SUPPORT_BOT',
  alert_bot: 'ALERT_BOT',
  visual_review_bot: 'VISUAL_REVIEW_BOT',
  service_user: 'SERVICE_USER',
  ghost: 'GHOST',
  project_bot: 'PROJECT_BOT',
  migration_bot: 'MIGRATION_BOT',
  security_bot: 'SECURITY_BOT',
  automation_bot: 'AUTOMATION_BOT',
  security_policy_bot: 'SECURITY_POLICY_BOT',
  admin_bot: 'ADMIN_BOT',
  suggested_reviewers_bot: 'SUGGESTED_REVIEWERS_BOT',
  service_account: 'SERVICE_ACCOUNT',
  llm_bot: 'LLM_BOT',
  placeholder: 'PLACEHOLDER',
  duo_code_review_bot: 'DUO_CODE_REVIEW_BOT',
  import_user: 'IMPORT_USER',
};
